import normalizeUrl from "@/utils/normalizeUrl";
import {
  FacebookOutlined,
  Instagram,
  LanguageOutlined,
  LinkedIn,
  MusicVideoSharp,
  Pinterest,
  Twitter,
  YouTube,
} from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/joy";
import { ReactNode } from "react";

export type SocialIconType =
  | "website"
  | "facebook"
  | "twitter"
  | "youtube"
  | "instagram"
  | "linkedin"
  | "pinterest"
  | "tiktok";

const SOCIAL_ICON_CONFIG: Record<SocialIconType, { label: string; icon: ReactNode }> = {
  website: { label: "Website", icon: <LanguageOutlined /> },
  facebook: { label: "Facebook", icon: <FacebookOutlined /> },
  twitter: { label: "Twitter", icon: <Twitter /> },
  youtube: { label: "YouTube", icon: <YouTube /> },
  instagram: { label: "Instagram", icon: <Instagram /> },
  linkedin: { label: "LinkedIn", icon: <LinkedIn /> },
  pinterest: { label: "Pinterest", icon: <Pinterest /> },
  tiktok: { label: "TikTok", icon: <MusicVideoSharp /> },
};

type SocialIconProps = {
  type: SocialIconType;
  link: string;
};

function SocialIcon({ type, link }: SocialIconProps) {
  const config = SOCIAL_ICON_CONFIG[type];
  if (!config) {
    return null;
  }

  return (
    <Tooltip title={config.label} placement="bottom" size="sm">
      <IconButton
        component="a"
        href={normalizeUrl(link)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={config.label}
        size="sm"
        variant="plain"
        sx={{
          "--IconButton-size": "30px",
          "--Icon-fontSize": "17px",
          borderRadius: "50%",
          color: "text.primary",
          backgroundColor: "rgba(255, 255, 255, 0.85)",
          "&:hover": { backgroundColor: "common.white", color: "primary.600" },
        }}
      >
        {config.icon}
      </IconButton>
    </Tooltip>
  );
}

export default SocialIcon;
